var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMillionCitizens(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 104,
    viewBox: "0 0 92 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8095 28.8375L27.2861 24.2778",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7522 24.2778L14.0215 29.0448",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4365 28.8375L50.9131 24.2778",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3791 24.2778L37.6484 29.0448",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0644 28.8375L74.541 24.2778",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0061 24.2778L61.2754 29.0448",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6018 80.6522L26.8711 75.8853",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1662 75.8853L14.4355 80.6522",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2297 80.6522L50.499 75.8853",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.7934 75.8853L37.8555 80.8595",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.8566 80.6522L74.126 75.8853",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.4221 75.8853L61.6914 80.6522",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0432 54.745L62.3125 49.978",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6076 49.978L49.877 54.9523",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8303 54.5377L39.0996 49.978",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3947 50.1851L26.6641 55.1593",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5848 89.1953C16.7702 87.0099 16.7702 83.4667 14.5848 81.2813C12.3994 79.0959 8.85621 79.0959 6.67084 81.2813C4.48546 83.4667 4.48546 87.0099 6.67084 89.1953C8.85621 91.3806 12.3994 91.3806 14.5848 89.1953Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4098 95.3679C19.4098 96.197 19.2025 97.026 19.2025 97.8551C18.5807 100.342 16.3009 102 13.8138 102H7.596C5.10889 102 2.82904 100.342 2.20726 97.8551C2 97.026 2 96.197 2 95.3679C2 92.0518 3.86533 90.1865 6.76696 89.3574C7.80326 90.3937 9.25408 91.0155 10.7049 91.0155C12.1557 91.0155 13.6065 90.3937 14.6428 89.3574C17.5445 90.1865 19.4098 92.0518 19.4098 95.3679Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2127 89.1957C40.3981 87.0104 40.3981 83.4672 38.2127 81.2818C36.0273 79.0964 32.4841 79.0964 30.2988 81.2818C28.1134 83.4672 28.1134 87.0104 30.2988 89.1957C32.4841 91.3811 36.0273 91.3811 38.2127 89.1957Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0365 95.3679C43.0365 96.197 43.0365 97.026 42.8293 97.8551C42.2075 100.342 39.9276 102 37.6478 102H31.43C28.9429 102 26.663 100.342 26.0412 97.8551C25.834 97.026 25.834 96.197 25.834 95.3679C25.834 92.0518 27.6993 90.1865 30.6009 89.3574C31.6372 90.3937 33.0881 91.0155 34.5389 91.0155C35.9897 91.0155 37.4405 90.3937 38.4768 89.3574C41.1712 90.1865 43.0365 92.0518 43.0365 95.3679Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8367 89.2001C64.0221 87.0148 64.0221 83.4716 61.8367 81.2862C59.6514 79.1008 56.1082 79.1008 53.9228 81.2862C51.7374 83.4716 51.7374 87.0148 53.9228 89.2001C56.1082 91.3855 59.6514 91.3855 61.8367 89.2001Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6637 95.3679C66.6637 96.197 66.6637 97.026 66.2492 97.8551C65.6274 100.342 63.3475 102 61.0677 102H54.8499C52.3628 102 50.0829 100.342 49.4612 97.8551C49.2539 97.026 49.2539 96.197 49.2539 95.3679C49.2539 92.0518 51.1192 90.1865 54.0209 89.3574C55.0572 90.3937 56.508 91.0155 57.9588 91.0155C59.4096 91.0155 60.8604 90.3937 61.8967 89.3574C64.7984 90.1865 66.6637 92.0518 66.6637 95.3679Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4637 89.1987C87.6491 87.0133 87.6491 83.4701 85.4637 81.2847C83.2783 79.0994 79.7351 79.0994 77.5497 81.2847C75.3644 83.4701 75.3644 87.0133 77.5497 89.1987C79.7351 91.384 83.2783 91.3841 85.4637 89.1987Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2926 95.3679C90.2926 96.197 90.2926 97.026 89.8781 97.8551C89.2563 100.342 86.9764 102 84.6966 102H78.4788C75.9917 102 73.7118 100.342 73.0901 97.8551C72.8828 97.026 72.8828 96.197 72.8828 95.3679C72.8828 92.0518 74.7481 90.1865 77.6498 89.3574C78.6861 90.3937 80.1369 91.0155 81.5877 91.0155C83.0385 91.0155 84.4893 90.3937 85.5256 89.3574C88.4273 90.1865 90.2926 92.0518 90.2926 95.3679Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4588 63.4731C28.6442 61.2877 28.6442 57.7445 26.4588 55.5591C24.2734 53.3738 20.7302 53.3738 18.5449 55.5591C16.3595 57.7445 16.3595 61.2877 18.5449 63.4731C20.7302 65.6585 24.2734 65.6585 26.4588 63.4731Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2233 69.4607C31.2233 70.2898 31.2233 71.1188 31.016 71.9478C30.3942 74.4349 28.1144 76.093 25.6273 76.093H19.4095C16.9224 76.093 14.6425 74.4349 14.0207 71.9478C13.8135 71.1188 13.8135 70.2898 13.8135 69.4607C13.8135 66.1446 15.6788 64.2792 18.5804 63.4502C19.6167 64.4865 21.0676 65.1083 22.5184 65.1083C23.9692 65.1083 25.42 64.4865 26.4563 63.4502C29.3579 64.2792 31.2233 66.1446 31.2233 69.4607Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0867 63.4755C52.2721 61.2902 52.2721 57.747 50.0867 55.5616C47.9014 53.3762 44.3582 53.3762 42.1728 55.5616C39.9874 57.747 39.9874 61.2902 42.1728 63.4755C44.3582 65.6609 47.9014 65.6609 50.0867 63.4755Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.851 69.4607C54.851 70.2898 54.851 71.1188 54.6437 71.9478C54.0219 74.4349 51.7421 76.093 49.4622 76.093H43.2444C40.7573 76.093 38.4775 74.4349 37.8557 71.9478C37.6484 71.1188 37.6484 70.2898 37.6484 69.4607C37.6484 66.1446 39.5138 64.2792 42.4154 63.4502C43.4517 64.4865 44.9025 65.1083 46.3533 65.1083C47.8041 65.1083 49.255 64.4865 50.2913 63.4502C52.9856 64.2792 54.851 66.1446 54.851 69.4607Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.7108 63.476C75.8961 61.2906 75.8961 57.7475 73.7108 55.5621C71.5254 53.3767 67.9822 53.3767 65.7968 55.5621C63.6114 57.7474 63.6114 61.2906 65.7968 63.476C67.9822 65.6614 71.5254 65.6614 73.7108 63.476Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4791 69.4607C78.4791 70.2898 78.4791 71.1188 78.0646 71.9478C77.4428 74.4349 75.163 76.093 72.8831 76.093H66.6653C64.1782 76.093 61.8984 74.4349 61.2766 71.9478C61.0693 71.1188 61.0693 70.2898 61.0693 69.4607C61.0693 66.1446 62.9347 64.2792 65.8363 63.4502C66.8726 64.4865 68.3234 65.1083 69.7742 65.1083C71.4323 65.1083 72.6759 64.4865 73.7122 63.4502C76.6138 64.2792 78.4791 66.1446 78.4791 69.4607Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7147 37.7382C16.9 35.5528 16.9 32.0097 14.7147 29.8243C12.5293 27.6389 8.9861 27.6389 6.80072 29.8243C4.61535 32.0097 4.61535 35.5528 6.80072 37.7382C8.9861 39.9236 12.5293 39.9236 14.7147 37.7382Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4098 43.76C19.4098 44.5891 19.2025 45.4181 19.2025 46.2471C18.5807 48.7343 16.3009 50.3923 13.8138 50.3923H7.596C5.10889 50.3923 2.82904 48.7343 2.20726 46.2471C2 45.4181 2 44.5891 2 43.76C2 40.4439 3.86533 38.5785 6.76696 37.7495C7.80326 38.7858 9.25408 39.4076 10.7049 39.4076C12.1557 39.4076 13.6065 38.7858 14.6428 37.7495C17.5445 38.5785 19.4098 40.4439 19.4098 43.76Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3387 37.7382C40.5241 35.5528 40.5241 32.0097 38.3387 29.8243C36.1533 27.6389 32.6101 27.6389 30.4247 29.8243C28.2394 32.0097 28.2394 35.5528 30.4247 37.7382C32.6101 39.9236 36.1533 39.9236 38.3387 37.7382Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.0365 43.76C43.0365 44.5891 43.0365 45.4181 42.8293 46.2471C42.2075 48.7343 39.9276 50.3923 37.6478 50.3923H31.43C28.9429 50.3923 26.663 48.7343 26.0412 46.2471C25.834 45.4181 25.834 44.5891 25.834 43.76C25.834 40.4439 27.6993 38.5785 30.6009 37.7495C31.6372 38.7858 33.0881 39.4076 34.5389 39.4076C35.9897 39.4076 37.4405 38.7858 38.4768 37.7495C41.1712 38.5785 43.0365 40.4439 43.0365 43.76Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9656 37.7407C64.151 35.5553 64.151 32.0121 61.9656 29.8267C59.7803 27.6413 56.2371 27.6413 54.0517 29.8267C51.8663 32.0121 51.8663 35.5553 54.0517 37.7407C56.2371 39.926 59.7803 39.926 61.9656 37.7407Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6637 43.76C66.6637 44.5891 66.6637 45.4181 66.2492 46.2471C65.6274 48.7343 63.3475 50.3923 61.0677 50.3923H54.8499C52.3628 50.3923 50.0829 48.7343 49.4612 46.2471C49.2539 45.4181 49.2539 44.5891 49.2539 43.76C49.2539 40.4439 51.1192 38.5785 54.0209 37.7495C55.0572 38.7858 56.508 39.4076 57.9588 39.4076C59.4096 39.4076 60.8604 38.7858 61.8967 37.7495C64.7984 38.5785 66.6637 40.4439 66.6637 43.76Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5916 37.7412C87.777 35.5558 87.777 32.0126 85.5916 29.8272C83.4062 27.6418 79.863 27.6418 77.6777 29.8272C75.4923 32.0126 75.4923 35.5558 77.6777 37.7412C79.8631 39.9265 83.4062 39.9265 85.5916 37.7412Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.2926 43.76C90.2926 44.5891 90.2926 45.4181 89.8781 46.2471C89.2563 48.7343 86.9764 50.3923 84.6966 50.3923H78.4788C75.9917 50.3923 73.7118 48.7343 73.0901 46.2471C72.8828 45.4181 72.8828 44.5891 72.8828 43.76C72.8828 40.4439 74.7481 38.5785 77.6498 37.7495C78.6861 38.7858 80.1369 39.4076 81.5877 39.4076C83.0385 39.4076 84.4893 38.7858 85.5256 37.7495C88.4273 38.5785 90.2926 40.4439 90.2926 43.76Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4412 11.871C28.6266 9.68566 28.6266 6.14247 26.4412 3.95709C24.2559 1.77172 20.7127 1.77172 18.5273 3.95709C16.3419 6.14247 16.3419 9.68566 18.5273 11.871C20.7127 14.0564 24.2559 14.0564 26.4412 11.871Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2233 18.0598C31.2233 18.8889 31.2233 19.7179 31.016 20.5469C30.3942 23.0341 28.1144 24.4849 25.6273 24.4849H19.4095C16.9224 24.4849 14.6425 22.8268 14.0207 20.5469C14.0207 19.5107 13.8135 18.6816 13.8135 18.0598C13.8135 14.7437 15.6788 12.8784 18.5804 12.0493C19.6167 13.0856 21.0676 13.7074 22.5184 13.7074C23.9692 13.7074 25.42 13.0856 26.4563 12.0493C29.3579 12.8784 31.2233 14.5364 31.2233 18.0598Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0672 11.8715C52.2526 9.68615 52.2526 6.14295 50.0672 3.95758C47.8818 1.7722 44.3386 1.7722 42.1533 3.95758C39.9679 6.14295 39.9679 9.68615 42.1533 11.8715C44.3386 14.0569 47.8818 14.0569 50.0672 11.8715Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.851 18.0598C54.851 18.8889 54.851 19.7179 54.6437 20.5469C54.0219 23.0341 51.7421 24.4849 49.4622 24.4849H43.2444C40.7573 24.4849 38.4775 22.8268 37.8557 20.5469C37.6484 19.7179 37.6484 18.8889 37.6484 18.0598C37.6484 14.7437 39.5138 12.8784 42.4154 12.0493C43.4517 13.0856 44.9025 13.7074 46.3533 13.7074C47.8041 13.7074 49.255 13.0856 50.2913 12.0493C52.9856 12.8784 54.851 14.5364 54.851 18.0598Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6942 11.872C75.8795 9.68663 75.8795 6.14345 73.6942 3.95807C71.5088 1.7727 67.9656 1.77269 65.7802 3.95807C63.5948 6.14344 63.5948 9.68664 65.7802 11.872C67.9656 14.0574 71.5088 14.0574 73.6942 11.872Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4791 18.0598C78.4791 18.8889 78.4791 19.7179 78.0646 20.5469C77.4428 23.0341 75.163 24.4849 72.8831 24.4849H66.6653C64.1782 24.4849 61.8984 22.8268 61.2766 20.5469C61.0693 19.7179 61.0693 18.8889 61.0693 18.0598C61.0693 14.7437 62.9347 12.8784 65.8363 12.0493C66.8726 13.0856 68.3234 13.7074 69.7742 13.7074C71.4323 13.7074 72.6759 13.0856 73.7122 12.0493C76.6138 12.8784 78.4791 14.5364 78.4791 18.0598Z",
    stroke: "black",
    strokeWidth: 2.5,
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMillionCitizens);
export default __webpack_public_path__ + "static/media/million-citizens.70964dd0474a3243470b49fb47265c63.svg";
export { ForwardRef as ReactComponent };